// @flow

import React, { Component } from 'react';
import './serviceUnavailable.css';

class ServiceUnavailable extends Component {

  render() {
    return (
      <div className="service-unavailable">
        <h2>ERROR 503!</h2>
      </div>
    );
  }
}

export default ServiceUnavailable;



// WEBPACK FOOTER //
// ./src/components/common/serviceUnavailable/serviceUnavailable.js